export default {
  path: '/v2',
  component: r => require(['@/v2/views/components/BasePage'], r),
  children: [
    {
      path: '/v2/errorbook/index',
      name: 'ErrorBookIndex',
      component: r => require(['@/v3/modules/errorbook/views/index'], r),
      meta: {
        title: '错题管理',
        keepAlive: true,
        parentPath: '/v2/errorbook/index'
      }
    },
    {
      path: '/v2/errorbook/analysis',
      name: 'ErrorBookAnalysis',
      component: r => require(['@/v3/modules/errorbook/views/analysis'], r),
      meta: {
        title: '学情分析',
        keepAlive: false,
        parentPath: '/v2/errorbook/index'
      }
    },
    {
      path: '/v2/errorbook/export',
      name: 'ErrorBookExport',
      component: r => require(['@/v3/modules/errorbook/views/export'], r),
      meta: {
        title: '导出记录',
        keepAlive: false,
        parentPath: '/v2/errorbook/index'
      }
    }
  ]
}
